<template>
  <v-container :fluid="$vuetify.display.mdAndDown">
    <p class="text-h5 pb-2 px-4">Accountant</p>
    <p class="body pb-5 px-4">On this page you can manage all client details about payments, account statistics, current balance.</p>
    <alert-card
        v-if="alert.visible === true"
        v-model:visible="alert.visible"
        :type="alert.type"
        :title="alert.title"
        :text="alert.text"
        :closable="false"
    />
    <accountant-filter
        :currency-options="Object.values(Currency)"
        v-model:valid="filter.valid"
        v-model:username="filter.username"
        v-model:name="filter.name"
        v-model:balance-from="filter.balanceFrom"
        v-model:balance-to="filter.balanceTo"
        v-model:currency="filter.currency"
    />
    <accountant-list
        :items="items"
        :skeleton-amount="limit"
        :loading="loading"
    />
    <v-pagination
        v-model="this.page"
        :length="this.pageAmount"
    />
  </v-container>
</template>

<script>

import AccountantList from "@/components/Accountant/AccountantList.vue";
import AccountantFilter from "@/components/Accountant/AccountantFilter.vue";
import {auth} from "@/common/auth";
import {router} from "@/router";
import {api} from "@/common/api";
import {inject} from "vue";
import debounce from "lodash.debounce";
import {Currency} from "@/common/enum/currency";
import AlertCard from "@/components/AlertCard.vue";
import {messages} from "@/common/enum/messages";
import {numbers} from "@/common/numbers";

export default {
  name: "AccountantClientsView",
  components: {AlertCard, AccountantFilter, AccountantList},
  data() {
    return {
      clientsRequest: null,
      filter: {
        valid: true,
        username: null,
        name: null,
        balanceFrom: null,
        balanceTo: null,
        currency: null
      },
      items: [],
      page: 1,
      limit: 10,
      total: 0,
      loading: false,
      alert: {
        visible: false,
        type: 'error',
        title: 'Error',
        text: ''
      }
    }
  },
  computed: {
    Currency() {
      return Currency
    },
    pageAmount() {
      return Math.ceil(this.total / this.limit)
    }
  },
  watch: {
    page() {
      this.loadClients(this.filter)
    },
    filter: {
      handler: debounce(function(filter) {
        this.loadClients(filter)
      }, 500),
      deep: true,
      immediate: true
    },
  },
  setup() {
    return {
      switchAuthorizationState: inject('authorization').switchState
    }
  },
  mounted() {
    this.loadClients(this.filter)
  },
  methods: {
    loadClients(filter) {
      const token = auth.getToken()
      if (token == null) {
        this.switchAuthorizationState()
        router.push({name: 'sign-in', state: {redirectTo: 'home'}})
        return
      }

      if (this.filter.valid !== true) {
        return
      }

      if (this.clientsRequest && !this.clientsRequest.signal.aborted) {
        this.clientsRequest.abort()
      }

      this.clientsRequest = new AbortController()
      this.loading = true
      api.getClientsAccountant(token, {
        page: this.page,
        limit: this.limit,
        username: filter.username,
        name: filter.name,
        balance_from: filter.balanceFrom,
        balance_to: filter.balanceTo,
        currency: filter.currency
      }, this.clientsRequest.signal, this.setClients)
    },
    setClients(response) {
      this.loading = false
      if (response?.data?.status === 'error') {
        this.alert.visible = true
        this.alert.type = 'error'
        this.alert.title = 'Error'
        this.alert.text = response.data?.message?.length === 0 ? messages.en.accountant_user_list_view.users_loading_error : response.data.message
        return
      }

      this.alert.visible = false
      const users = response.data.users
      this.total = response.data.total
      this.items = users.map(user => {
        return {
          id: user.id,
          username: user.username,
          name: user.first_name !== null && user.last_name !== null ? user.first_name + ' ' + user.last_name : 'Not provided',
          balances: user.balances.map(balance => {
            return numbers.formatMoney(balance.balance, balance.currency)
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>